import React from 'react';
import { CareerOutlookFact } from 'labxchange-client';
import { sanitizeConfigOptions, sanitizeUnsafeHTML } from '@labxchange/util-sanitization';

interface CareerOutlookFactCardProps {
  cardNumber: number;
  fact: CareerOutlookFact;
}

const CareerOutlookFactCard: React.FC<CareerOutlookFactCardProps> = ({ cardNumber, fact }) => {
  return (
    <div className='fact-card'>
      <div className='fact-body'>
        <div className='content'>
            <div className='badge'>{`#${cardNumber}`}</div>
            <div
              className='description'
              dangerouslySetInnerHTML={{
                __html: sanitizeUnsafeHTML(fact.details, sanitizeConfigOptions.UnsafeHTMLSimple)
              }}
            />
        </div>
        <img className='header-image' src={fact.factImage}></img>
      </div>
      <div
        className='fact-footer'
        dangerouslySetInnerHTML={{
          __html: sanitizeUnsafeHTML(fact.sourceText, sanitizeConfigOptions.UnsafeHTMLSimple)
        }}
      />
    </div>
  );
};

export default CareerOutlookFactCard;
